import { render, staticRenderFns } from "./upgrade-account.vue?vue&type=template&id=aaf3b662&scoped=true&"
import script from "./upgrade-account.vue?vue&type=script&lang=js&"
export * from "./upgrade-account.vue?vue&type=script&lang=js&"
import style0 from "./upgrade-account.vue?vue&type=style&index=0&id=aaf3b662&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf3b662",
  null
  
)

export default component.exports